import {useLocation} from "react-router-dom";

const useQuery = () => {
    const {search} = useLocation()
    let url = new URL(window.location.href)
    const query_params = new URLSearchParams(search);

    const get = (key: string) => {
        return query_params.get(key)
    }

    const set = (key: string, value: any) => {
        return url.searchParams.set(key, value)
    }

    return {
        get, set
    }
}

export default useQuery;